import React from "react";
import Popup from "../../../popup/Popup/Popup";
import PopupContent from "../../../popup/PopupContent/PopupContent";
import Collection from "../../../../domain/Collection";
import SharingCollection from "../SharingCollection/SharingCollection";
import { IProject } from "../../../../services/WedApi/Models/Project";

interface PropsInterface {
    open: boolean;
    handleClose: (isUpdate?: boolean) => void;
    collection: Collection;
    project?: IProject;
    onChange: () => void;
}

interface StateInterface {}

export class SharingCollectionPopup extends React.Component<PropsInterface, StateInterface> {
    constructor(props: PropsInterface) {
        super(props);
        this.closePopup = this.closePopup.bind(this);
    }

    private closePopup() {
        this.props.handleClose();
    }

    render() {
        return (
            <Popup open={this.props.open} handleClose={this.closePopup} maxWidth="sm">
                <PopupContent>
                    <SharingCollection
                        close={this.props.handleClose}
                        collection={this.props.collection}
                        project={this.props.project}
                        onChange={this.props.onChange}
                    />
                </PopupContent>
            </Popup>
        );
    }
}
